// extracted by mini-css-extract-plugin
export default {"home_menu":"Menu_home_menu_ha72W","no_transition":"Menu_no_transition_Jo5vV"};